import {
  COMMENTS_REQUEST,
  COMMENTS_RECEIVE,
  COMMENTS_FAILURE,
  COMMENTS_PERMISSIONS_REQUEST,
  COMMENTS_PERMISSIONS_RECEIVE,
  COMMENTS_PERMISSIONS_FAILURE,
  ADD_COMMENT_REQUEST,
  ADD_COMMENT_SUCCESS,
  ADD_COMMENT_FAILURE,
  DELETE_COMMENT_REQUEST,
  DELETE_COMMENT_SUCCESS,
  DELETE_COMMENT_FAILURE,
  RESTORE_COMMENT_REQUEST,
  RESTORE_COMMENT_SUCCESS,
  RESTORE_COMMENT_FAILURE,
} from '../action-types';

export const fetchComments = (clubId, mediaType, mediaId) => async (dispatch) => {
  try {
    dispatch({ type: COMMENTS_REQUEST, payload: { clubId, mediaType, mediaId } });
    // Get the data from the API
    const { makeIsomorphicApiRequest } = await import('../../lib/api-proxy');
    const response = await makeIsomorphicApiRequest(
      `v2/club-website/${clubId}/comments/${mediaType}/${mediaId}`,
    );
    if (response.status !== 200) {
      dispatch({ type: COMMENTS_FAILURE, payload: { clubId, mediaType, mediaId } });
      return;
    }

    // Parse the response
    const { comments, canAdminister, canComment } = await response.json();
    dispatch({
      type: COMMENTS_RECEIVE,
      payload: { clubId, mediaType, mediaId, comments },
    });

    dispatch({
      type: COMMENTS_PERMISSIONS_RECEIVE,
      payload: { clubId, mediaType, mediaId, canAdminister, canComment },
    });
  } catch (error) {
    dispatch({ type: COMMENTS_FAILURE, payload: { clubId, mediaType, mediaId, error } });
  }
};

export const fetchCommentPermissions = (clubId, mediaType, mediaId) => async (dispatch) => {
  try {
    dispatch({ type: COMMENTS_PERMISSIONS_REQUEST, payload: { clubId, mediaType, mediaId } });
    const { makeIsomorphicApiRequest } = await import('../../lib/api-proxy');
    const response = await makeIsomorphicApiRequest(
      `v2/club-website/${clubId}/comments/${mediaType}/${mediaId}/permissions`,
    );

    if (response.status !== 200) {
      dispatch({ type: COMMENTS_PERMISSIONS_FAILURE, payload: { clubId, mediaType, mediaId } });
      return;
    }

    const { canAdminister, canComment } = await response.json();
    dispatch({
      type: COMMENTS_PERMISSIONS_RECEIVE,
      payload: { clubId, mediaType, mediaId, canAdminister, canComment },
    });
  } catch (error) {
    dispatch({
      type: COMMENTS_PERMISSIONS_FAILURE,
      payload: { clubId, mediaType, mediaId, error },
    });
  }
};

export const postComment = (clubId, mediaType, mediaId, text, replyingTo) => async (dispatch) => {
  try {
    dispatch({ type: ADD_COMMENT_REQUEST, payload: { clubId, mediaType, mediaId, replyingTo } });
    const { makeIsomorphicApiRequest } = await import('../../lib/api-proxy');
    const response = await makeIsomorphicApiRequest(
      `v2/club-website/${clubId}/comments/${mediaType}/${mediaId}`,
      {
        method: 'POST',
        body: JSON.stringify({ text, replyingTo }),
      },
    );

    if (response.status !== 201 && response.status !== 200) {
      dispatch({
        type: ADD_COMMENT_FAILURE,
        payload: { clubId, mediaType, mediaId, replyingTo },
      });
      return;
    }

    const data = await response.json();
    dispatch({
      type: ADD_COMMENT_SUCCESS,
      payload: { clubId, mediaType, mediaId, replyingTo, comment: data },
    });
  } catch (error) {
    dispatch({
      type: ADD_COMMENT_FAILURE,
      payload: { clubId, mediaType, mediaId, replyingTo, error },
    });
  }
};

export const deleteComment =
  (clubId, mediaType, mediaId, commentId, parentId) => async (dispatch) => {
    try {
      dispatch({
        type: DELETE_COMMENT_REQUEST,
        payload: { clubId, mediaType, mediaId, commentId, parentId },
      });

      const { makeIsomorphicApiRequest } = await import('../../lib/api-proxy');
      const response = await makeIsomorphicApiRequest(
        `v2/club-website/${clubId}/comments/${mediaType}/${mediaId}/${commentId}`,
        {
          method: 'DELETE',
        },
      );

      if (response.status !== 200) {
        dispatch({
          type: DELETE_COMMENT_FAILURE,
          payload: { clubId, mediaType, mediaId, commentId, parentId },
        });
        return;
      }

      const data = await response.json();
      dispatch({
        type: DELETE_COMMENT_SUCCESS,
        payload: { clubId, mediaType, mediaId, commentId, comment: data },
      });
    } catch (error) {
      dispatch({
        type: DELETE_COMMENT_FAILURE,
        payload: { clubId, mediaType, mediaId, commentId, parentId, error },
      });
    }
  };

export const restoreComment =
  (clubId, mediaType, mediaId, commentId, parentId) => async (dispatch) => {
    try {
      dispatch({
        type: RESTORE_COMMENT_REQUEST,
        payload: { clubId, mediaType, mediaId, commentId, parentId },
      });
      const { makeIsomorphicApiRequest } = await import('../../lib/api-proxy');
      const response = await makeIsomorphicApiRequest(
        `v2/club-website/${clubId}/comments/${mediaType}/${mediaId}/restore/${commentId}`,
        {
          method: 'POST',
        },
      );

      if (response.status !== 200) {
        dispatch({
          type: RESTORE_COMMENT_FAILURE,
          payload: { clubId, mediaType, mediaId, commentId, parentId },
        });
        return;
      }

      const data = await response.json();
      dispatch({
        type: RESTORE_COMMENT_SUCCESS,
        payload: { clubId, mediaType, mediaId, commentId, comment: data },
      });
    } catch (error) {
      dispatch({
        type: RESTORE_COMMENT_FAILURE,
        payload: { clubId, mediaType, mediaId, commentId, parentId, error },
      });
    }
  };
